import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';
import cn from 'classnames';
import { useAction } from 'hooks';
import App from 'modules/App';
export const DateInput = ({ id, popUpName, momentDate, disabled, isInProgress = false, onChange })=>{
    const locale = useSelector(App.selectors.locale);
    const openDropdown = useAction(App.actions.openDropdown, popUpName);
    const [value, setValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const intl = useIntl();
    useEffect(()=>{
        setValue(momentDate ? momentDate.clone().locale(locale).format('L') : '');
    }, [
        locale,
        momentDate
    ]);
    const name = intl.formatMessage(App.messages.placeholders[id]);
    const onDateChange = (evt)=>{
        setValue(evt.target.value);
        if (!evt.target.value) return;
        const newMomentDate = moment.utc(evt.target.value, 'L');
        const isValid = newMomentDate.isValid();
        if (!isValid) return;
        const isAfterDisabled = !disabled || !disabled.before || newMomentDate.isSameOrAfter(disabled.before);
        if (!isAfterDisabled) return;
        const isBeforeDisabled = !disabled || !disabled.after || newMomentDate.isSameOrBefore(disabled.after);
        if (!isBeforeDisabled) return;
        onChange(newMomentDate);
    };
    const onClick = (evt)=>{
        evt.stopPropagation();
    };
    const onFocus = ()=>{
        setIsFocused(true);
        openDropdown();
    };
    const onBlur = ()=>{
        setIsFocused(false);
        setValue(momentDate ? momentDate.clone().locale(locale).format('L') : '');
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "DateInput",
        children: /*#__PURE__*/ _jsx("input", {
            type: "text",
            id: id,
            name: id,
            className: cn('DateInput_input', {
                DateInput_input__focused: isFocused
            }),
            "aria-label": name,
            placeholder: name,
            autoComplete: "off",
            value: value,
            disabled: isInProgress,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onDateChange
        })
    });
};
